// src/utils/firestoreErrors.js
// Kept apart from the hooks so that a module with no auth dependency (the
// cache hook) can ask the question without importing the auth context.

/** Did Firestore refuse this read under the rules? */
export function isPermissionDenied(error) {
  if (!error) return false;
  if (error.code === 'permission-denied' || error.code === 'firestore/permission-denied') return true;
  return /missing or insufficient permissions/i.test(error.message || '');
}

export default isPermissionDenied;
